export default __webpack_public_path__ + "static/media/RICS.f5db6e4d.svg";